(ns bp-clients.tv-app.db
  "Namespace to initialize the app's db (state)"
  (:require
   [bp-clients.tv-app.auth.events :as auth]
   [bp-clients.tv-app.router :as router]
   [bp-clients.tv-app.utils.logger :as logger]
   [re-frame.core :as rf :refer [reg-event-fx reg-sub inject-cofx reg-global-interceptor reg-event-db]]))

(def initial-app-db
  "Initial db (state) used to bootstrap the app
  This can be used to mock an initial app state when testing."
  {})

(defn on-state-init
  "Gets executed after the init state (::initialized-db) event is sent."
  [event [_ initial-state token]]
  (let [db          (or initial-state initial-app-db)
        user-token  (or (-> event ::auth/auth-token) token)
        user-token? (seq user-token)]
    (router/start!)

    (let [session-id (str (random-uuid))]
      (rf/dispatch [:bp-clients.tv-app.analytics.events/set-session-id session-id])
      (logger/set-session-id! session-id))

    (if user-token?
      {:db (assoc db :loaded-db? true)
       :dispatch-n [[::auth/get-token-success user-token]
                    [::auth/login]]}
      {:db (assoc db :loaded-db? true)
       :dispatch [::auth/sign-in]})))

(defn- state-sub
  "Returns the whole state"
  [db]
  db)

(defn- loaded-db-sub
  "Returns if db is loaded"
  [db]
  (:loaded-db? db))

(defn- set-loaded-db-ev
  [db [_ loaded?]]
  (assoc db :loaded-db? loaded?))

(reg-event-db ::set-loaded-db set-loaded-db-ev)
(reg-event-fx ::initialize-db [(inject-cofx ::auth/auth-token)] on-state-init)
(reg-sub ::state state-sub)
(reg-sub ::loaded-db? loaded-db-sub)

(when ^boolean goog.DEBUG
  (reg-global-interceptor rf/debug))
